// Own audio cards — the calls to /api/audio-cards/* (el-bank-backend
// src/audio_cards/routes.py). Errors carry the server's message (German,
// written for the user) in `message`.
import { API_BASE_URL, getAuthHeaders } from '../auth';

async function json(res) {
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body.error || `HTTP ${res.status}`);
    err.status = res.status;
    err.unavailable = !!body.unavailable;
    throw err;
  }
  return body;
}

const send = (method, path, body) => fetch(`${API_BASE_URL}${path}`, {
  method,
  headers: getAuthHeaders({ 'Content-Type': 'application/json' }),
  body: body === undefined ? undefined : JSON.stringify(body),
}).then(json);

export const listCards = (language) =>
  fetch(`${API_BASE_URL}/api/audio-cards?language=${encodeURIComponent(language || 'de')}`,
    { headers: getAuthHeaders() }).then(json);

export const listClients = (model) =>
  fetch(`${API_BASE_URL}/api/audio-cards/clients?model=${encodeURIComponent(model)}`,
    { headers: getAuthHeaders() }).then(json);

export const createCard = (card, extra = {}) => send('POST', '/api/audio-cards', { card, ...extra });
export const updateCard = (id, card) => send('PUT', `/api/audio-cards/${id}`, { card });
export const deleteCard = (id) => send('DELETE', `/api/audio-cards/${id}`);
export const orderCards = (ids) => send('POST', '/api/audio-cards/order', { ids });
export const previewCard = (card, language) => send('POST', '/api/audio-cards/preview', { card, language });

export const renderCard = (id, language, refresh = false) =>
  fetch(`${API_BASE_URL}/api/audio-cards/${id}/render?language=${encodeURIComponent(language || 'de')}`
    + (refresh ? '&refresh=1' : ''), { headers: getAuthHeaders() }).then(json);

export const TURN_URL = () => `${API_BASE_URL}/api/audio-cards/turn`;
